import {AnyAction} from 'redux';

const CONFIRM_EXIT_VALUE='CONFIRM_EXIT_VALUE';
const initialState = {
    confirmexitvalue: ""
};

export async function setConfirmExitValue(dispatch:any, confirmexitvalue:any) {
  dispatch({
    type: CONFIRM_EXIT_VALUE,
    data: confirmexitvalue
  });
}

const confirmExitValueReducer= (state = initialState, action:AnyAction) => {
switch (action.type) {
  case CONFIRM_EXIT_VALUE: {
      return {
        ...state,
        confirmexitvalue: action.data
      };
    }

    default:
      return state;
  }
};

export default confirmExitValueReducer;